var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5903_54489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7762 21.259C26.815 27.2139 31.9708 29.2096 32.0279 29.235C31.9839 29.3745 31.1954 32.0565 29.2933 34.8238C27.649 37.2164 25.9428 39.5999 23.2651 39.642C20.634 39.6833 19.7924 38.0701 16.7845 38.0618C13.7774 38.0536 12.8333 39.5639 10.3426 39.6551C7.75778 39.746 5.79702 37.0506 4.15235 34.6578C0.791524 29.7633 -1.76259 20.8371 1.7164 14.826C3.44469 11.8409 6.52378 9.95609 9.86035 9.91671C12.3984 9.87521 14.789 11.6401 16.3406 11.6444C17.8911 11.6486 20.8079 9.5421 23.8673 9.86106C25.1483 9.91798 28.7433 10.3927 31.0431 13.7839C30.8567 13.8989 26.7452 16.2807 26.7762 21.259ZM21.8718 6.6236C23.2485 4.96411 24.1784 2.65123 23.9328 0.346717C21.9547 0.420885 19.5597 1.65454 18.1364 3.31299C16.861 4.78158 15.7411 7.13468 16.0353 9.39373C18.2393 9.57059 20.495 8.28414 21.8718 6.6236Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5903_54489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 39.3481,
    fill: "white",
    transform: "translate(0.109375 0.28125) rotate(0.157475)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.5012ebbd3e406bdedfc59ed96b1bd90f.svg";
export { ForwardRef as ReactComponent };